import React, { SVGProps } from 'react';

const StatusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="StatusIcon">
    <path
      d="M1.153 2.355 8 .833l6.848 1.522a.833.833 0 0 1 .652.813v8.323a5 5 0 0 1-2.227 4.16L8 19.167 2.727 15.65A5 5 0 0 1 .5 11.49V3.169a.833.833 0 0 1 .653-.813Zm1.014 1.482v7.654a3.333 3.333 0 0 0 1.484 2.773L8 17.164l4.35-2.9a3.334 3.334 0 0 0 1.483-2.772V3.837L8 2.542 2.167 3.837ZM8 9.167A2.083 2.083 0 1 1 8 5a2.083 2.083 0 0 1 0 4.167Zm-3.728 4.166a3.75 3.75 0 0 1 7.455 0H4.272Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--walletMenuBackground)"
      strokeWidth={0.6}
    />
  </svg>
);

export default StatusIcon;
